import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatofrmHero = styled.section`
	text-align: center;
	overflow: hidden;
	padding: 50px 20px;
	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;
	color: ${CSSVars.white};
	position: relative;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.hero-wrapper {
		.platform-img-wrapper {
			transform: translate(50%, -50%) scale(1.8);
			left: -40px;
			bottom: 40px;
			position: absolute;
			opacity: 0.2;

			img {
				min-height: 60px;
				max-width: 600px;
				max-height: 600px;
				object-fit: contain;
				position: relative !important;
			}
		}

		h1 {
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 750px;
			text-align: left;
			margin: 30px auto 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 50px auto 30px;
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize3XL};
			}

			span {
				text-transform: capitalize;
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 300;
			max-width: 1200px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
